import {LogLevel} from "angular-auth-oidc-client";

export const environment = {
  production: true,
  appName: 'AnTeA',
  appVersion: 'beta',
  apiUrl: 'https://antea.iss.it/test/api',
  apiSentrynelUrl: 'https://antea.iss.it/test/sentrynel-be/api',
  dashboardSentrynelUrl: 'https://antea.iss.it/test/sentrynel/',
  apiWszUrl: 'https://test.antea.cloud/wsz/api',
  shapeFile : 'https://test.antea.cloud/shapefile/convert',
  secure: true,
  keycloak: {
    authority: 'https://antea.iss.it/test/iam/',
    redirectUrl: 'https://antea.iss.it/test/portal/login_success', //'https://cot.we-com.local/',
    postLogoutRedirectUri: 'https://antea.iss.it/test/portal/',
    clientId: 'antea_test',
    scope: 'openid profile email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    startCheckSession: true,
    logLevel: LogLevel.Error,
    historyCleanupOff: false,
    realms: 'antea'
  },
  faro:{
    enabled: true,
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/5d0a47d258ae0e6bde87ffe3c11d274f',
  },
  googleMapsApiKey: "AIzaSyBuzr3xmTd-weYgeaRehm-q33J5EnQt-YA"
};
